export default __webpack_public_path__ + "static/media/GHLogo.5eab40a0.png";